import type { MapDataPayload } from '@/types/map';

const base = ['map'];

export const mapKeys = {
    getMapData: (params?: MapDataPayload) => (params ? [...base, 'get-map-data', params] : [...base, 'get-map-data']),
} as const;
